{
	"name": "serveox-mvp",
	"version": "0.55.2",
	"scripts": {
		"ng": "ng",
		"start": "ng serve --configuration local",
		"start:local": "ng serve --port 3000 --host 0.0.0.0",
		"build": "ng build",
		"build:local": "ng build --configuration local",
		"build:dev": "ng build --configuration development",
		"build:prod": "ng build --configuration production",
		"watch": "ng build --watch --configuration development",
		"cap:sync": "npx cap sync",
		"cap:copy": "npx cap copy",
		"cap:open:ios": "npx cap open ios",
		"cap:run:ios": "npx cap run ios -l --external",
		"cap:update:ios": "npx cap update ios",
		"test": "ng test",
		"lint": "ng lint",
		"update-version": "tsx scripts/update-version.ts"
	},
	"private": true,
	"dependencies": {
		"@angular/animations": "^19.2.9",
		"@angular/cdk": "^19.2.14",
		"@angular/common": "^19.2.9",
		"@angular/compiler": "^19.2.9",
		"@angular/core": "^19.2.9",
		"@angular/fire": "^19.1.0",
		"@angular/forms": "^19.2.9",
		"@angular/google-maps": "^19.2.14",
		"@angular/platform-browser": "^19.2.9",
		"@angular/platform-browser-dynamic": "^19.2.9",
		"@angular/router": "^19.2.9",
		"@angular/service-worker": "^19.2.9",
		"@capacitor-firebase/analytics": "^7.2.0",
		"@capacitor-firebase/app-check": "^7.2.0",
		"@capacitor-firebase/authentication": "^7.2.0",
		"@capacitor/android": "^7.2.0",
		"@capacitor/angular": "^2.0.3",
		"@capacitor/app": "^7.0.1",
		"@capacitor/camera": "^7.0.1",
		"@capacitor/core": "^7.2.0",
		"@capacitor/device": "^7.0.1",
		"@capacitor/ios": "^7.2.0",
		"@capacitor/keyboard": "^7.0.2",
		"@capacitor/push-notifications": "^7.0.1",
		"@capacitor/splash-screen": "^7.0.1",
		"@capacitor/toast": "^7.0.1",
		"@googlemaps/js-api-loader": "^1.16.8",
		"@ng-bootstrap/ng-bootstrap": "^18.0.0",
		"@ng-select/ng-select": "^14.7.0",
		"@popperjs/core": "^2.11.8",
		"@types/google.maps": "^3.58.1",
		"angular-calendar": "^0.31.1",
		"bootstrap": "^5.3.3",
		"bootstrap-icons": "^1.11.3",
		"date-fns": "^4.1.0",
		"firebase": "^11.6.1",
		"google-libphonenumber": "^3.2.41",
		"libphonenumber-js": "^1.12.8",
		"ngx-intl-tel-input": "^17.0.0",
		"rxjs": "~7.8.0",
		"signature_pad": "^5.0.4",
		"tslib": "^2.8.1",
		"zone.js": "~0.15.0"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "^19.2.10",
		"@angular-eslint/builder": "19.3.0",
		"@angular-eslint/eslint-plugin": "19.3.0",
		"@angular-eslint/eslint-plugin-template": "19.3.0",
		"@angular-eslint/schematics": "19.3.0",
		"@angular-eslint/template-parser": "19.3.0",
		"@angular/cli": "^19.2.10",
		"@angular/compiler-cli": "^19.2.9",
		"@angular/localize": "^19.2.9",
		"@capacitor/assets": "^3.0.5",
		"@capacitor/cli": "^7.2.0",
		"@ionic/cli": "^7.2.0",
		"@types/bootstrap": "^5.2.10",
		"@types/jasmine": "~5.1.0",
		"@typescript-eslint/eslint-plugin": "7.11.0",
		"@typescript-eslint/parser": "7.11.0",
		"eslint": "^8.57.0",
		"eslint-config-prettier": "^9.1.0",
		"eslint-plugin-prettier": "^5.2.1",
		"jasmine-core": "~5.1.0",
		"karma": "~6.4.0",
		"karma-chrome-launcher": "~3.2.0",
		"karma-coverage": "~2.2.0",
		"karma-jasmine": "~5.1.0",
		"karma-jasmine-html-reporter": "~2.1.0",
		"native-run": "^2.0.1",
		"prettier": "^3.3.3",
		"prettier-eslint": "^16.3.0",
		"tsx": "^4.19.2",
		"typescript": "~5.5.4"
	}
}
